var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('div',{staticClass:"menu-spacer"}),_c('router-view',{staticClass:"page-fades"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }